import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function ContactPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('submitting');

    // Simulate form submission
    setTimeout(() => {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setTimeout(() => setSubmitStatus('idle'), 3000);
    }, 1500);
  };

  const contactInfo = [
    {
      icon: 'ri-phone-fill',
      title: 'Phone',
      details: '+44 20 1234 5678',
      link: 'tel:+442012345678',
      color: 'from-[#0B3C5D] to-[#0B3C5D]/80'
    },
    {
      icon: 'ri-mail-fill',
      title: 'Email',
      details: 'support@task-budy.co.uk',
      link: 'mailto:support@task-budy.co.uk',
      color: 'from-[#FF6A00] to-[#FF6A00]/80'
    },
    {
      icon: 'ri-map-pin-fill',
      title: 'Office',
      details: '123 Business Street, London, UK',
      link: 'https://maps.google.com',
      color: 'from-[#0B3C5D] to-[#0B3C5D]/80'
    },
    {
      icon: 'ri-time-fill',
      title: 'Hours',
      details: 'Mon-Fri: 8am-8pm, Sat-Sun: 9am-6pm',
      link: null,
      color: 'from-[#FF6A00] to-[#FF6A00]/80'
    }
  ];

  return (
    <div className="min-h-screen bg-white w-full">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white shadow-md`}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/a3382d87126fc476a032aa8f5ebcbb38/e0dadf219d3b341a9184e92001cfe9b6.png" 
                alt="Taskbudy" 
                className="h-8 lg:h-12 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Home
              </Link>
              <Link to="/services" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Services
              </Link>
              <Link to="/locations" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Locations
              </Link>
              <Link to="/pricing" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Pricing
              </Link>
              <Link to="/about" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                About
              </Link>
              <Link to="/contact" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Contact
              </Link>
              <Link to="/auth/signin" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Sign In
              </Link>
              <Link to="/auth/signup" className="text-[#0F2A44] hover:text-[#fe7a14] font-medium transition-colors whitespace-nowrap">
                Sign Up
              </Link>
              <Link
                to="/provider-signup"
                className="bg-[#fe7a14] hover:bg-[#e56a0f] text-white px-6 py-3 rounded-xl font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Become a Provider
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-[#0F2A44] w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu Dropdown */}
          {mobileMenuOpen && (
            <div className="fixed top-[58px] left-0 right-0 bg-white shadow-lg z-40 border-t border-gray-200 animate-slideDown">
              <div className="flex flex-col py-2 max-h-[calc(100vh-58px)] overflow-y-auto">
                <Link
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Home
                </Link>
                <Link
                  to="/services"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Services
                </Link>
                <Link
                  to="/locations"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Locations
                </Link>
                <Link
                  to="/pricing"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Pricing
                </Link>
                <Link
                  to="/about"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  About
                </Link>
                <Link
                  to="/contact"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Contact
                </Link>
                <div className="border-t border-gray-200 my-2"></div>
                <Link
                  to="/auth/signin"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Sign In
                </Link>
                <Link
                  to="/auth/signup"
                  onClick={() => setMobileMenuOpen(false)}
                  className="px-4 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-orange-50 hover:to-transparent font-medium transition-all duration-300 cursor-pointer transform hover:translate-x-1"
                >
                  Sign Up
                </Link>
                <Link
                  to="/provider-signup"
                  onClick={() => setMobileMenuOpen(false)}
                  className="mx-4 my-2 px-4 py-3 bg-gradient-to-r from-[#fe7a14] to-[#ff8c3a] text-white font-bold rounded-lg text-center hover:from-[#e56a0f] hover:to-[#fe7a14] transition-all duration-300 cursor-pointer whitespace-nowrap transform hover:scale-105 shadow-md"
                >
                  Become a Provider
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-[#0B3C5D]/10 to-[#FF6A00]/10 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B3C5D] mb-4 sm:mb-6 animate-[fadeInUp_0.8s_ease-out]">
              Get In Touch
            </h1>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed animate-[fadeInUp_1s_ease-out] px-4">
              Have a question or need assistance? We're here to help! Reach out to us and we'll get back to you as soon as possible.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-5 sm:p-6 shadow-lg hover:shadow-2xl transition-all duration-500 group cursor-pointer border border-gray-100 animate-[fadeInUp_0.8s_ease-out]"
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={() => info.link && window.open(info.link, '_blank')}
              >
                <div className={`w-12 h-12 sm:w-14 sm:h-14 bg-gradient-to-br ${info.color} rounded-xl flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300`}>
                  <i className={`${info.icon} text-white text-xl sm:text-2xl`}></i>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-[#0B3C5D] mb-2">{info.title}</h3>
                <p className="text-xs sm:text-sm text-gray-600 break-words">{info.details}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form & Map Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12">
            {/* Contact Form */}
            <div className="animate-[fadeInLeft_1s_ease-out]">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-xl">
                <h2 className="text-xl sm:text-2xl font-bold text-[#0B3C5D] mb-4 sm:mb-6">Send Us a Message</h2>
                
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none input-micro input-focus-glow"
                      placeholder="John Smith"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none input-micro input-focus-glow"
                      placeholder="john@example.com"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none input-micro input-focus-glow"
                      placeholder="+44 7XXX XXXXXX"
                    />
                  </div>

                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                      Subject
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none input-micro input-focus-glow"
                      placeholder="How can we help?"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows={6}
                      required
                      maxLength={500}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none resize-none input-micro input-focus-glow"
                      placeholder="Tell us more about your inquiry..."
                    />
                    <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
                  </div>

                  <button
                    type="submit"
                    disabled={submitStatus === 'submitting'}
                    className="w-full px-8 py-4 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer btn-micro btn-ripple"
                  >
                    {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
                  </button>
                </form>
              </div>
            </div>

            {/* Map & Additional Info */}
            <div className="space-y-8 animate-[fadeInRight_1s_ease-out]">
              {/* Map */}
              <div className="bg-white rounded-2xl overflow-hidden shadow-xl h-96">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2483.5436076814437!2d-0.12775492346709845!3d51.50735097181395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487604b900d26973%3A0x4291f3172409ea92!2slondon!5e0!3m2!1sen!2suk!4v1704123456789!5m2!1sen!2suk"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Taskbudy Office Location"
                ></iframe>
              </div>

              {/* FAQ Quick Links */}
              <div className="bg-gradient-to-br from-[#0B3C5D] to-[#0B3C5D]/90 rounded-2xl p-6 sm:p-8 text-white shadow-xl">
                <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">Quick Help</h3>
                <p className="text-sm sm:text-base text-white/90 mb-4 sm:mb-6">
                  Looking for quick answers? Check out our FAQ section or browse our help center.
                </p>
                <div className="space-y-2 sm:space-y-3">
                  <a
                    href="/"
                    className="flex items-center gap-3 text-white hover:text-[#FF6A00] transition-colors cursor-pointer group"
                  >
                    <i className="ri-question-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
                    <span className="text-sm sm:text-base group-hover:translate-x-1 transition-transform duration-300">Frequently Asked Questions</span>
                  </a>
                  <a
                    href="/"
                    className="flex items-center gap-3 text-white hover:text-[#FF6A00] transition-colors cursor-pointer group"
                  >
                    <i className="ri-book-open-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
                    <span className="text-sm sm:text-base group-hover:translate-x-1 transition-transform duration-300">Help Center</span>
                  </a>
                  <a
                    href="/"
                    className="flex items-center gap-3 text-white hover:text-[#FF6A00] transition-colors cursor-pointer group"
                  >
                    <i className="ri-customer-service-2-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
                    <span className="text-sm sm:text-base group-hover:translate-x-1 transition-transform duration-300">Live Chat Support</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}
